import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { cycleClamp } from "../../../../utils/math";
import { FrameSwitcherAnimated } from "./Animated";

/**
 * This component extends `FrameSwitcherAnimated` and add touch and mouse events handlers. It also
 * handle infinte scroll and scroll position adjustment.
 */
export var FrameSwitcherEventHandler = /*#__PURE__*/function (_FrameSwitcherAnimate) {
  _inherits(FrameSwitcherEventHandler, _FrameSwitcherAnimate);
  var _super = _createSuper(FrameSwitcherEventHandler);
  function FrameSwitcherEventHandler() {
    var _this;
    _classCallCheck(this, FrameSwitcherEventHandler);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Represet if component is controlled by finger, mouse or control funcion right now
     * @type {boolean}
     */
    _defineProperty(_assertThisInitialized(_this), "isControlled", false);
    /**
     * Represet if scroll border adjustment in progress
     * @type {boolean}
     */
    _defineProperty(_assertThisInitialized(_this), "adjustmentInProgress", false);
    /**
     * Move to nearest frame start
     */
    _defineProperty(_assertThisInitialized(_this), "adjustScrollToFrame", function () {
      if (_this.isControlled) {
        return Promise.resolve();
      }
      var frame = _this.getFrameUnderScrollPosition();
      var pointDisplace = _this.props.placeholderWidth - _this.scroll;
      var endPoint = pointDisplace + frame * _this.moveFactor;
      if (_this.props.cycle) {
        var cycleEndPoint = endPoint + _this.props.frames.length * _this.moveFactor;
        if (Math.abs(endPoint) > Math.abs(cycleEndPoint)) {
          endPoint = cycleEndPoint;
        }
      }
      if (endPoint === 0) {
        return Promise.resolve();
      }
      _this.adjustmentInProgress = true;
      return _this.moveBy(endPoint, 250).then(function () {
        return _this.setActiveFrame(frame);
      }).then(function () {
        _this.adjustmentInProgress = false;
      });
    });
    /**
     * Implements infinte scroll effect if `cycle` prop is `true`
     */
    _defineProperty(_assertThisInitialized(_this), "adjustScrollToScrollBorders", function () {
      if (!_this.props.cycle) {
        return Promise.resolve();
      }
      var start = _this.props.placeholderWidth;
      var end = _this.props.frames.length * _this.moveFactor + start;
      return _this.scrollTo(cycleClamp(end, start)(_this.scroll));
    });
    _defineProperty(_assertThisInitialized(_this), "adjustmentTimeoutId", null);
    /**
     * Debounce `adjustScrollToFrame` execution
     */
    _defineProperty(_assertThisInitialized(_this), "debounceScrollAdjustment", function () {
      clearTimeout(_this.adjustmentTimeoutId);
      if (_this.adjustmentInProgress || _this.isControlled) {
        return;
      }

      // Minimal 50ms to catch momentum scrolling stop event
      var delay = Math.max(50, _this.props.adjustmentTimeout);
      _this.adjustmentTimeoutId = setTimeout(_this.adjustScrollToFrame, delay);
    });
    /**
     * Event handler for component scroll event
     */
    _defineProperty(_assertThisInitialized(_this), "handleScrollEvent", function () {
      _this.debounceScrollAdjustment();
      _this.adjustScrollToScrollBorders();
    });
    /**
     * Event handlers for touch events
     */
    _defineProperty(_assertThisInitialized(_this), "handleTouchStart", function () {
      _this.cancleActiveAnimation();
      _this.stopAutoSwitch();
      _this.isControlled = true;
      _this.adjustmentInProgress = false;
      var handleTouchEnd = function handleTouchEnd() {
        _this.content.removeEventListener('touchend', handleTouchEnd);
        _this.content.removeEventListener('touchcancel', handleTouchEnd);
        _this.isControlled = false;
        _this.debounceScrollAdjustment();
      };
      _this.content.addEventListener('touchend', handleTouchEnd, {
        passive: true
      });
      _this.content.addEventListener('touchcancel', handleTouchEnd, {
        passive: true
      });
    });
    /**
     * Event handlers for mouse events
     */
    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      _this.cancleActiveAnimation();
      _this.stopAutoSwitch();
      _this.isControlled = true;
      _this.adjustmentInProgress = false;
      var buildMouseMove = function buildMouseMove() {
        var prevPos = event.clientX;
        return function (e) {
          _this.scrollBy(prevPos - e.clientX);
          prevPos = e.clientX;
        };
      };
      var handleMouseMove = buildMouseMove();
      var handleMouseUp = function handleMouseUp() {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        _this.isControlled = false;
        _this.debounceScrollAdjustment();
      };
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    });
    /**
     * Event handler to prevent Drag'n'Drop
     */
    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (event) {
      return event.preventDefault();
    });
    return _this;
  }
  _createClass(FrameSwitcherEventHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(FrameSwitcherEventHandler.prototype), "componentDidMount", this).call(this);
      if (this.props.draggable) {
        this.content.addEventListener('mousedown', this.handleMouseDown);
      }
      this.content.addEventListener('scroll', this.handleScrollEvent, {
        passive: true
      });
      this.content.addEventListener('dragstart', this.handleDragStart);
      if (FrameSwitcherEventHandler.isNative) {
        this.content.addEventListener('touchstart', this.handleTouchStart, {
          passive: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(FrameSwitcherEventHandler.prototype), "componentWillUnmount", this).call(this);
      this.content.removeEventListener('scroll', this.handleScrollEvent);
      this.content.removeEventListener('touchstart', this.handleTouchStart);
      this.content.removeEventListener('dragstart', this.handleDragStart);
      clearTimeout(this.adjustmentTimeoutId);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      _get(_getPrototypeOf(FrameSwitcherEventHandler.prototype), "componentWillReceiveProps", this).call(this, props);
      if (this.props.draggable !== props.draggable) {
        var method = props.draggable ? 'addEventListener' : 'removeEventListener';
        this.content[method]('mousedown', this.handleMouseDown);
      }
    }
  }, {
    key: "changeFrame",
    value:
    /**
     * Switches frame by delta. It uses `this.move` function to change frame.
     *
     * It won't be executed if any animation in progress already.
     *
     * It sets `FrameSwitcherEventHandler.isControlled` to
     * `true` on start and switch it to `false` on end
     * @param {number} delta Direction and amount of frames to scroll throught
     */
    function changeFrame() {
      var _get2,
        _this2 = this;
      this.isControlled = true;
      for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }
      return (_get2 = _get(_getPrototypeOf(FrameSwitcherEventHandler.prototype), "changeFrame", this)).call.apply(_get2, [this].concat(rest)).then(function () {
        _this2.isControlled = false;
      });
    }
  }]);
  return FrameSwitcherEventHandler;
}(FrameSwitcherAnimated);